import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import ScrollToTop from '@/components/feature/ScrollToTop';
import Hero from './components/Hero';
import FeaturedSection from './components/FeaturedSection';
import CategoryGrid from './components/CategoryGrid';
import NewsSection from './components/NewsSection';
import FAQSection from './components/FAQSection';

export default function Home() {
  return (
    <>
      <ScrollToTop />
      <Navbar />
      <main>
        <Hero />
        <FeaturedSection />
        <CategoryGrid />
        <NewsSection />
        <FAQSection />
      </main>
      <Footer />
    </>
  );
}